export default "__VITE_ASSET__Ch8BWolq__"